export const NOTIFICATION_INFO_REQUEST = 'NOTIFICATION_INFO_REQUEST';
export const NOTIFICATION_INFO_SUCCESS = 'NOTIFICATION_INFO_SUCCESS';
export const NOTIFICATION_INFO_FAILURE = 'NOTIFICATION_INFO_FAILURE';

export const CALL_INFO_REQUEST = 'CALL_INFO_REQUEST';
export const CALL_INFO_SUCCESS = 'CALL_INFO_SUCCESS';
export const CALL_INFO_FAILURE = 'CALL_INFO_FAILURE';
